/* eslint-disable max-lines */
import React, { useRef, useState } from "react";
import { connect } from "react-redux";

import { navigateToLogin } from "../../../history";
import {
  removeProperties,
  localStorage,
} from "../../../services";
import {
  selectResults,
  selectControlFields,
  searchAds,
  selectCriteriaModules,
  updateCriteriaModules,
  clearAdsSearchResults
} from "../search.ducks";
import {
  LocalStorageKey,
  QueryParam
} from "../../../models/enums";
import {
  checkEmptyObject,
  getUrlParams,
} from "../../../services/utils";
import { getCreatorInfo } from "../../Ad/ad.ducks";
import { selectFavoriteIds } from "../../Favorite/favorite.ducks";
import {
  selectCurrentModule,
  selectCategories,
  selectModules,
  selectCurrentCategories
} from "../../../containers/App/selectors";
import { getFilteredCategories, updateFilteredCategories } from "../../../containers/App/actions";
import { selectLoadedUser } from "../../Auth/auth.ducks";
import { mapCategoryToHr } from "../../LanguageMapper";
import { useHandleSearch } from "./hooks/useHandleSearch";
import { useInitialSearch } from "./hooks/useInitialSearch";
import { useTags } from "./hooks/useTags";
import { useUpdateUrlParams } from "./hooks/useUpdateUrlParams";
import { useHandleOnSubmit } from "./hooks/useHandleOnSubmit";
import { useUpdateSearchOnChange } from "./hooks/useUpdateSearchOnChange";

// Options:
// - runSearch: only the search page fetches results through this HOC. The module
//   and sub level pages share it for the tags, breadcrumbs and url handling; they
//   must not search, because General renders them through an inline component
//   that re-mounts on every App render and an immediate (cached) search result
//   would re-mount and re-search them endlessly.
// eslint-disable-next-line max-lines-per-function
export default (Com, { runSearch = false } = {}) => {
  const SearchPageComponent = props => {

    const state = useRef({
      tags: [],
      routeLinks: [],
      numberOfControls: 0,
      loading: true
    });

    const queryParams = useRef({});
    const [isSaveModalVisible, setIsSaveModalVisible] = useState(false);

    const updateUrlParams = useUpdateUrlParams(props)
    const { generateTags, handleTagRemove, handleResetAllTags } = useTags(props, queryParams, state, updateUrlParams)
    const handleSearch = useHandleSearch(props, state, queryParams, generateTags, runSearch)
    useInitialSearch(props, handleSearch, queryParams)
    const handleOnSubmit = useHandleOnSubmit(queryParams, updateUrlParams)

    useUpdateSearchOnChange(props, queryParams, handleSearch, generateTags)


    const handleSaveSearchOpen = () => {
      setIsSaveModalVisible(true);
    };

    const handleSaveSearchCancel = () => {
      setIsSaveModalVisible(false);
    };

    const handleSaveSearchSubmit = (values, onSubmit) => {
      const { module, user } = props;

      if (
        !checkEmptyObject(
          removeProperties(queryParams.current, "category", "text")
        )
      ) {
        queryParams.current = {
          ...queryParams.current,
          ...getUrlParams(window.location.search, QueryParam.searchQuery)
        };
      }


      const saveSearchData = {
        criteria: queryParams.current,
        // @ts-ignore
        text: queryParams.current.text,
        name: values.name,
        notifyFrequency: values.notifyFrequency
      };

      if (module) {
        // @ts-ignore
        saveSearchData.module = module;
        // @ts-ignore
        if (queryParams.current.category) {
          // @ts-ignore
          saveSearchData.category = queryParams.current.category;
        }
      }

      if (!user) {
        localStorage.setItem(LocalStorageKey.savedSearch, saveSearchData);
        handleSaveSearchCancel();
        navigateToLogin();
        return;
      }

      onSubmit(saveSearchData);
      setIsSaveModalVisible(false);
    };


    const {
      tags,
      routeLinks,
      numberOfControls,
      loading
    } = state.current;

    return (
      <Com
        onSearchSubmit={handleOnSubmit}
        isSaveSearchFormVisible={isSaveModalVisible}
        onSaveSearchCancel={handleSaveSearchCancel}
        onSaveSearchSubmit={handleSaveSearchSubmit}
        onSaveClick={handleSaveSearchOpen}
        onTagRemove={handleTagRemove}
        tags={tags}
        onResetAllTags={handleResetAllTags}
        routeLinks={routeLinks}
        numberOfControls={numberOfControls}
        // @ts-ignore
        selectedCategory={mapCategoryToHr(queryParams.current.category)}
        loading={loading}
        {...props}
        modules={null}
      />
    );
  };

  SearchPageComponent.defaultProps = {
    ads: {},
    controlFields: {},
    favoriteIds: [],
    configuration: {},
    location: {},
    user: null
  };

  return connect(
    (state: any) => ({
      module: selectCurrentModule(state),
      ads: selectResults(state),
      // scoped configuration datasets (makes, subcategories, resolved locations)
      // used to label the tags and build the seo url
      configuration: state.configuration,
      controlFields: selectControlFields(state),
      favoriteIds: selectFavoriteIds(state),
      modules: selectModules(state),
      categories: selectCategories(state),
      criteriaModules: selectCriteriaModules(state),
      user: selectLoadedUser(state),
      // @ts-ignore
      location: state.router.location,
      filteredCategories: selectCurrentCategories(state)
    }),
    {
      getCreatorInfo,
      searchAds,
      clearAdsSearchResults,
      updateCriteriaModules,
      getFilteredCategories,
      updateFilteredCategories
    }
  )(SearchPageComponent);
};



// WEBPACK FOOTER //
// ./src/routes/Search/HOCs/handleSearchPage.tsx